export const URL = globalThis.URL;
export const URLSearchParams = globalThis.URLSearchParams;
